/**
 * Property reducer
 *
 * @author Anh Tu Le <anh.le@vertics.co>
 *
 * @copyright Vertics Co 2019
 */
import {
    PROPERTY_GET_PROPERTIES,
    PROPERTY_GET_PROPERTIES_SUCCESS,
    PROPERTY_GET_PROPERTIES_FAIL,
    PROPERTY_GET_SELECTED_PROPERTY,
    PROPERTY_UPDATE_PROPERTY,
    PROPERTY_UPDATE_PROPERTY_SUCCESS,
    PROPERTY_UPDATE_PROPERTY_FAIL,
    PROPERTY_CHANGE_FIELD,
    PROPERTY_DELETE_PROPERTY,
    PROPERTY_DELETE_PROPERTY_SUCCESS,
    PROPERTY_DELETE_PROPERTY_FAIL,

} from './../actions'
const initialState = {
    properties: [],
    entriesCount: 0,
    pageNumber: 1,
    selectedProperty: null,
    loading: false,
    error: null
}
export const propertyReducer = (state = initialState, action) => {
    switch (action.type) {
        case PROPERTY_CHANGE_FIELD:
            return {
                ...state,
                [action.name]: action.value
            }
            case PROPERTY_GET_SELECTED_PROPERTY:
                return {
                    ...state,
                    selectedProperty: action.property
                }
                case PROPERTY_GET_PROPERTIES:
                    return {
                        ...state,
                        loading: true
                    }
                    case PROPERTY_GET_PROPERTIES_SUCCESS:
                        const {
                            results, entriesCount, pageNumber
                        } = action.payload.data
                        return {
                            ...state,
                            loading: false,
                                properties: results,
                                entriesCount,
                                pageNumber
                        }
                        case PROPERTY_GET_PROPERTIES_FAIL:
                            return {
                                ...state,
                                loading: false
                            }
                            case PROPERTY_UPDATE_PROPERTY:
                                return {
                                    ...state, loading: true
                                }
                                case PROPERTY_UPDATE_PROPERTY_SUCCESS:
                                    return {
                                        ...state, loading: false
                                    }
                                    case PROPERTY_UPDATE_PROPERTY_FAIL:
                                        return {
                                            ...state, loading: false
                                        }
                                        case PROPERTY_DELETE_PROPERTY:
                                            return {
                                                ...state,
                                                loading: true
                                            }
                                            case PROPERTY_DELETE_PROPERTY_SUCCESS:
                                                return {
                                                    ...state,
                                                    loading: false
                                                }
                                                case PROPERTY_DELETE_PROPERTY_FAIL:
                                                    return {
                                                        ...state,
                                                        loading: false
                                                    }
                                                    default:
                                                        return state
    }
}
export const propertySelectors = {
    getPageNumber: (state = initialState) => state.pageNumber,
    getEntriesCount: (state = initialState) => state.entriesCount,
    getSelectedProperties: (state = initialState) => state.selectedProperty,
    getProperties: (state = initialState) => state.properties,
    getLoading: (state = initialState) => state.loading,
    getError: (state = initialState) => state.error
}